import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import { get } from "@rails/request.js"

export default class TomSelectController extends Controller {
  static targets = ["input"]

  static values = {
    url: String,
    valueField: { type: String, default: "title" },
    labelField: { type: String, default: "title" },
    searchField: { type: String },
    sortField: { type: String },
    maxItems: { type: Number, default: -1 },
    clearAfterSelect: { type: Boolean, default: true }
  }

  initialize() {
  }

  connect() {
    this.create()
  }

  disconnect() {
    this.destroy()
  }

  // ==============
  // = TOM-select =
  // ==============

  create() {
    const maxItems = (this.maxItemsValue >= 0) ? this.maxItemsValue : null
    const labelField = this.labelFieldValue
    const sortField = this.sortFieldValue ?? labelField
    const searchField = this.searchFieldValue ?? labelField

    const fetchOptions = this.fetchOptions.bind(this)

    const baseOptions = {
      create: true,
      persist: false,
      valueField: this.valueFieldValue,
      labelField,
      clearAfterSelect: this.clearAfterSelectValue,
      searchField,
      sortField,
      maxItems,
      load: function (query, callback) {
        this.clearOptions()
        fetchOptions(query, callback)
      }
    }

    let options;
    if (maxItems > 1) {
      options = { ...baseOptions, plugins: ["remove_button"] }
    } else {
      options = { ...baseOptions }
    }

    this.tomSelect = new TomSelect(this.inputTarget, options)
  }

  destroy() {
    if (!this.tomSelect) { return }

    this.tomSelect.destroy()
    this.tomSelect = null
  }

  async fetchOptions(query, callback) {
    const url = this.urlValue.replace("QUERY", window.encodeURIComponent(query))

    const response = await get(url, {
      responseKind: "json"
    })

    if (response.ok) {
      const json = await response.json

      callback(json)
    } else {
      callback([])
    }
  }
}
